import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from './shared.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class Interceptor implements HttpInterceptor {
  private totalRequests = 0;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    public sharedService: SharedService,
    private dialog: MatDialog,
  ) { }

  ngOnDestroy() {
    this.sharedService.showErrorMessage.emit({error: "", displayError: false});
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.totalRequests++;
    this.spinner.show();

    const authToken = this.sharedService.getDataFromStorage('token');
    if (authToken && !request.headers.has('Authorization')) {
      request = request.clone({ setHeaders: { Authorization: authToken } });
    }

    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.spinner.hide();
        } else if (this.totalRequests < 0) {
          this.totalRequests = 0;
          this.spinner.hide();
        }
      }
    },
      ((exception) => {
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.spinner.hide();
        } else if (this.totalRequests < 0) {
          this.totalRequests = 0;
          this.spinner.hide();
        }

        if (exception && exception.status === 401) {
          this.sharedService.resetAllData();
          if (this.router.url !== '/') {
            this.router.navigate(['/']);
          }
          this.sharedService.showErrorMessage.emit({error: exception.statusText, displayError: true});
        } else {
          let errorMessage = '';

          if (exception && exception.error) {
            const isJson = this.isJson(exception.error);
            if (isJson) {
              exception.error = JSON.parse(exception.error);
            }

            if (exception.error.validationErrors || exception.error.ValidationErrors) {
              if (exception.error.validationErrors) {
                errorMessage = exception.error.validationErrors.map(m => m.errorMessage).join('<br/>');
              }
              if (exception.error.ValidationErrors) {
                errorMessage = exception.error.ValidationErrors.map(m => m.ErrorMessage).join('<br/>');
              }
            }
          }

          if (!errorMessage) {
            if (exception.statusText) {
              // errorMessage = exception.statusText;
            } else {
              errorMessage = exception.error;
            }
          }

          if (errorMessage) {
            this.sharedService.showErrorMessage.emit({error: errorMessage, displayError: true});
            this.sharedService.showPopupErrorMessage.emit({error: errorMessage, displayError: true});
          }
        }
      })
    ));
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
